export enum LoyaltyFeedCardType {
  /** Marketplace Item Link */
  MarketplaceItem = 1,
  /** Marketplace Event Link */
  MarketplaceEvent = 2,
  /** Auction Link */
  Auction = 3,
  /** Lotto Link */
  Lotto = 4,
  /** Play Trivia */
  Trivia = 5,
  /** Play Predictor */
  Predictor = 6,
  /** Play Poll */
  Poll = 7,
  /** Ads */
  Advert = 8,
  /** Voucher Code */
  VoucherCode = 9,
  /** Campaigns */
  OfferRow = 10,
  /** Wallet Link*/
  Wallet = 11,
}
